module.exports = __webpack_public_path__ + "img/team-4.4c60fc7e.jpg";